<template>
  <div>
    <input
      v-model="searchInputText"
      :placeholder="$t('general__text__search')"
      class="search-field"
      :class="{ 'search-field__split-view': isSplitIndoorViewer }"
    />
  </div>
</template>

<script>
import { navvisSearchRequest } from '../../services/navvis.service'
import { INDOORVIEWER_PREFIX } from '../../store/module-prefixes'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'SearchField',
  props: {
    inputMinLength: {
      type: Number,
      default: 3
    },
    inputDelay: {
      type: Number,
      default: 1000 // the delay before searching in milliseconds
    },
    searchRestURL: {
      type: [Object, String],
      default: ''
    },
    searchRestType: {
      type: String,
      default: 'navvis',
      validator: (value) => {
        // Add more if we in the future need to approach other APIs. Right now navvis is only possible choice
        return ['navvis'].indexOf(value) !== -1
      }
    }
  },
  emits: ['searchResults'],
  data() {
    return {
      searchInputText: '',
      results: []
    }
  },
  computed: {
    ...mapState(INDOORVIEWER_PREFIX, {
      navvisApiToken: (state) => state.navvisApiToken
    }),
    ...mapGetters(INDOORVIEWER_PREFIX, {
      isSplitIndoorViewer: 'isSplitIndoorViewer',
      navvisInstanceURL: 'navvisInstanceURL'
    })
  },
  watch: {
    searchInputText: function (input) {
      // Only search with words bigger than inputMinLength
      if (input.length >= this.inputMinLength) {
        setTimeout(() => {
          // Only perform the search action if the user has stopped typing
          if (input === this.searchInputText) {
            this.search(input)
          }
        }, this.inputDelay)
      }
    }
  },
  created() {},
  methods: {
    async search(searchInputText) {
      if (this.searchRestType === 'navvis') {
        if (this.navvisApiToken === '') {
          // If search type is navvis we need a token.
          console.error('No NavVis Token set')
        } else {
          const result = await navvisSearchRequest(
            this.navvisInstanceURL,
            searchInputText,
            this.navvisApiToken
          )
          this.$emit('searchResults', {
            result: result,
            searchInput: searchInputText
          })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@use '@/styles/variables.scss';
.search-field {
  background-color: variables.$color-grey-lighter;
  border: none;
  border-radius: variables.$border-radius-medium;
  box-shadow: variables.$box-shadow-button-and-search-field;
  font-family: variables.$font-family-general-paragraph;
  font-size: variables.$font-size-general-paragraph;
  font-weight: variables.$font-weight-general-paragraph;
  height: variables.$size-button-medium;
  min-width: 222px;
  outline: none;
  padding: variables.$margin-navigation-menu variables.$margin-navigation-menu
    variables.$margin-navigation-menu 15px;
  transition: min-width 0.4s ease-in;
  width: calc(
    #{variables.$width-app-navigation-menu} - #{variables.$size-button-medium} - #{variables.$margin-small} -
      #{variables.$margin-small} - 10px
  );
  -webkit-transition: min-width 0.4s ease-in;
  &__split-view {
    min-width: 60px !important;
    width: 60px;
    border-radius: variables.$border-radius-medium 20px 20px variables.$border-radius-medium;
    outline: 0;
    padding: variables.$margin-navigation-menu variables.$margin-navigation-menu
      variables.$margin-navigation-menu 15px;
    &:focus-within {
      min-width: 232px !important;
      width: calc(
        #{variables.$width-app-navigation-menu} - #{variables.$size-button-medium} - #{variables.$margin-small} -
          #{variables.$margin-small}
      ) !important;
      border-radius: variables.$border-radius-medium;
      outline: 0;
    }
  }
  @media screen and (max-width: 658px) {
    min-width: 60px !important;
    width: 60px;
    border-radius: variables.$border-radius-medium 20px 20px variables.$border-radius-medium;
    outline: 0;
    padding: variables.$margin-navigation-menu variables.$margin-navigation-menu
      variables.$margin-navigation-menu 15px;
    &:focus-within {
      min-width: calc(100vw - 114px) !important;
      width: calc(100vw - 114px) !important;
      border-radius: variables.$border-radius-medium;
      outline: 0;
    }
  }
}
</style>
